module.exports = __webpack_public_path__ + "static/media/gray-user.b43a1d6b.svg";